import { addToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  ThreadArchiveFromTeamsMeetingFeedFulfilledAction,
  ThreadUnarchiveFromTeamsMeetingFeedFulfilledAction,
} from '../../domains/archiveThreads/archiveThreadActions.types';
import type { FeedLoadFulfilledAction } from '../../domains/feedLoad/actions.types';

import type { ArchiveThreads } from './types';

export type ThreadsArchiveFromFeedsAction = ThreadArchiveFromTeamsMeetingFeedFulfilledAction;
export type ThreadsUnarchiveFromFeedsAction = ThreadUnarchiveFromTeamsMeetingFeedFulfilledAction;
export type ThreadsFeedLoadAction = FeedLoadFulfilledAction;

const initialState: ArchiveThreads = {};

const reducer: Reducer<
  ArchiveThreads,
  ThreadsArchiveFromFeedsAction | ThreadsUnarchiveFromFeedsAction | FeedLoadFulfilledAction
> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD.ARCHIVE_FROM_TEAMS_MEETING_FULFILLED': {
      return addToRecord(state, action.payload.threadId, true);
    }
    case 'THREAD.UNARCHIVE_FROM_TEAMS_MEETING_FULFILLED': {
      return addToRecord(state, action.payload.threadId, true);
    }
    case 'FEED.LOAD_FULFILLED': {
      return initialState;
    }
    default:
      return state;
  }
};

export default reducer;
